import { RESET_FORM } from '../actionTypes';
import { profileConfigurationActions } from '../reducer';

export default () => profileConfigurationActions[RESET_FORM]();
